import { createAsyncThunk } from "@reduxjs/toolkit";
import { getStudentReports } from "../../api/admin/studentReports.api";

/* ================= FETCH STUDENT REPORTS ================= */
/**
 * Supports two modes:
 * 1. All Students Summary: Pass { fromDate, toDate, page, limit }
 * 2. Single Student Details: Pass { studentId, fromDate, toDate } (Includes homework history)
 */
export const fetchStudentReports = createAsyncThunk(
  "admin/studentReports/fetch",
  async (
    { studentId = null, fromDate = "", toDate = "", page = 1, limit = 20 } = {},
    { rejectWithValue, signal }
  ) => {
    try {
      const res = await getStudentReports(
        {
          studentId,
          fromDate,
          toDate,
          page,
          limit,
        },
        { signal } // Enables automatic request cancellation on unmount/re-dispatch
      );

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to fetch student reports."
        );
      }

      return res;
    } catch (error) {
      // Ignore abort errors caused by intentional cancellation
      if (error.name === "AbortError") {
        throw error;
      }

      return rejectWithValue(
        error?.message || "An error occurred while fetching student reports."
      );
    }
  }
);